import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = (extra = {}) => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  ...extra,
});

// GET /api/promo-banner  ->  { status, size: {width, height}, data: {...} | null }
const get = async () => {
  const res = await axios.get(`${API_URL}promo-banner`, { headers: authHeaders() });
  return res.data;
};

// POST /api/promo-banner/save (multipart)  ->  { status, message, data }
const save = async (formData) => {
  const res = await axios.post(`${API_URL}promo-banner/save`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });
  return res.data;
};

export default { get, save };